import { render, staticRenderFns } from "./composeNotificationModal.vue?vue&type=template&id=b1b65840&scoped=true"
import script from "./composeNotificationModal.vue?vue&type=script&lang=js"
export * from "./composeNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./composeNotificationModal.vue?vue&type=style&index=0&id=b1b65840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b65840",
  null
  
)

export default component.exports